import { render, staticRenderFns } from "./RecognitionForm.vue?vue&type=template&id=a7a30218"
import script from "./RecognitionForm.vue?vue&type=script&lang=js"
export * from "./RecognitionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports